export default [
    {
        name: 'astroModel',
        type: 'gltfModel',
        path: 'models/astro.glb'
    }
]